<template>
    <div class="row items-start q-col-gutter-md q-mb-md">
        <div class="col">
            <GltnSelectEmpresa
                name="empresaId"
                v-model="empresaId"
                hide-hint
                emit-value
                map-options
                :errors="res.getErrors('empresa_id')"
            />
        </div>
        <div class="col">
            <GltnSelectAlicuota
                name="alicuotaId"
                v-model="alicuotaId"
                hide-hint
                emit-value
                map-options
                :errors="res.getErrors('alicuota_id')"
            />
        </div>
        <div class="col">
            <GltnSelectUbicacion
                name="ubicacionId"
                v-model="ubicacionId"
                hide-hint
                emit-value
                map-options
                :errors="res.getErrors('ubicacion_id')"
            />
        </div>
        <div class="col">
            <GltnSelectTipoVenta
                name="tipoVentaId"
                v-model="tipoVentaId"
                hide-hint
                emit-value
                map-options
                :errors="res.getErrors('tipo_venta_id')"
            />
        </div>
    </div>
</template>

<script setup>
import GltnSelectEmpresa from '@/components/form/GltnSelectEmpresa.vue';
import GltnSelectAlicuota from '@/components/form/GltnSelectAlicuota.vue';
import GltnSelectTipoVenta from '@/components/form/GltnSelectTipoVenta.vue';
import GltnSelectUbicacion from '@/components/form/GltnSelectUbicacion.vue';

const props = defineProps({
    res: Object,
});

const tipoVentaId = defineModel('tipoVentaId',{
    type: Number,
    default: 1
});
const ubicacionId = defineModel('ubicacionId',{
    type: Number,
    default: null
});
const alicuotaId = defineModel('alicuotaId',{
    type: Number,
    default: null
});
const empresaId = defineModel('empresaId',{
    type: Number,
    default: null
});
</script>
